import { StreamMessage as NewStreamMessage } from '@streamr/trackerless-network';
import { StreamMessageTranslator } from './StreamMessageTranslator';
export function convertStreamMessageToBytes(oldStreamMessage) {
    return NewStreamMessage.toBinary(StreamMessageTranslator.toProtobuf(oldStreamMessage));
}
export function convertBytesToStreamMessage(bytes) {
    return StreamMessageTranslator.toClientProtocol(NewStreamMessage.fromBinary(bytes));
}
//# sourceMappingURL=oldStreamMessageBinaryUtils.js.map